import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface StatsCardProps {
  title: string;
  value: string;
  icon: React.ReactNode;
  bgColor: string;
  iconColor: string;
}

export default function StatsCard({
  title,
  value,
  icon,
  bgColor,
  iconColor,
}: StatsCardProps) {
  return (
    <Card sx={{ height: "100%", boxShadow: 0 }}>
      <CardContent>
        <Box
          sx={{
            display: "inline-flex",
            p: 1.5,
            borderRadius: 2,
            bgcolor: bgColor,
            mb: 2,
          }}
        >
          {React.cloneElement(
            icon as React.ReactElement<Record<string, unknown>>,
            {
            sx: { color: iconColor, fontSize: 24 },
            }
          )}
        </Box>
        <Typography variant="h4" sx={{ mb: 0.5, fontWeight: 700 }}>
          {value}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {title}
        </Typography>
      </CardContent>
    </Card>
  );
}
